
import api from "../utils/api";

export const updatePassword = async (username, oldPassword, newPassword, confirmPassword) => {
  try {
    const response = await api.post("/change_password", {
      username,
      old_password: oldPassword,
      new_password: newPassword,
      confirm_password: confirmPassword,
    });
    return response.data;
  } catch (error) {
    console.error("Update password error:", error);
    throw error;
  }
};

/**
 * Password age for `username` — how long until the 2-month expiry, and whether
 * it has already lapsed. Stays reachable with an expired password (see
 * PASSWORD_EXEMPT_PATHS in the backend's dashboard_access_middleware.py).
 */
export const getPasswordStatus = async (username) => {
  const response = await api.get("/password_status", {
    params: { username },
    timeout: 10000,
  });
  return response.data;
};

export const updateEmail = async (username, currentEmail, newEmail) => {
  try {
    const response = await api.post("/change_email", {
      username,
      current_email: currentEmail,
      new_email: newEmail,
    });
    return response.data;
  } catch (error) {
    console.error("Update email error:", error);
    throw error;
  }
};

export const updatePhone = async (username, countryCode, phoneNumber) => {
  try {
    const response = await api.post("/update_phone", {
      username,
      country_code: countryCode,
      phone_number: phoneNumber,
    });
    return response.data;
  } catch (error) {
    console.error("Update phone error:", error);
    throw error;
  }
};

export const updateConsumerInfo = async (username, consumerId, sanctionedLoad, offlineMeterEmail) => {
  try {
    const payload = {
      username,
    };
    if (consumerId !== undefined && consumerId !== null) payload.consumer_id = consumerId;
    if (sanctionedLoad !== undefined && sanctionedLoad !== null) payload.sanctioned_load = sanctionedLoad;
    if (offlineMeterEmail !== undefined && offlineMeterEmail !== null) payload.offline_meter_email = offlineMeterEmail;

    const response = await api.post("/update_customer_info", payload);
    return response.data;
  } catch (error) {
    console.error("Update consumer info error:", error);
    throw error;
  }
};

export const updateUnitPrices = async (
  username,
  unitPrice,
  genUnitPrice,
  solarUnitPrice,
  peakUnitPrice,
) => {
  try {
    const payload = { username };
    if (unitPrice) payload.unit_price = String(unitPrice);
    if (peakUnitPrice) payload.peak_unit_price = String(peakUnitPrice);
    if (genUnitPrice) payload.gen_unitprice = String(genUnitPrice);
    if (solarUnitPrice) payload.solar_unitprice = String(solarUnitPrice);

    const response = await api.post("/update_unit_price", payload);
    return response.data;
  } catch (error) {
    console.error("Update unit prices error:", error);
    throw error;
  }
};

export const getConsumerInfo = async (username) => {
  try {
    const response = await api.get(`/get_customer_info?username=${encodeURIComponent(username)}`);
    return response.data;
  } catch (error) {
    console.error("Get consumer info error:", error);
    throw error;
  }
};

export const updateOfflineMeterEmail = async (username, offlineMeterEmail) => {
  try {
    const response = await api.post("/update_customer_info", {
      username,
      offline_meter_email: offlineMeterEmail,
    });
    return response.data;
  } catch (error) {
    console.error("Update offline meter email error:", error);
    throw error;
  }
};

export const deleteOfflineMeterEmail = async (username) => {
  try {
    const response = await api.delete(`/delete_offline_meter_email?username=${encodeURIComponent(username)}`);
    return response.data;
  } catch (error) {
    console.error("Delete offline meter email error:", error);
    throw error;
  }
};
